import axios from 'axios'
import * as types from '../mutation-types'
import {
  checkVariable,
} from '../../plugins/helper'

// state
export const state = {
  entireForm: false,
  loadingDates: true,
  errorDates: null,
  dates: [],
  selectedDate: null,
  loadingTimes: false,
  errorTimes: null,
  times: [],
  selectedTime: null,
  appointmentCostumerDetails: null,
}

// mutations
export const mutations = {
  [types.INITIALIZE_APPOINTMENT_STORE](state) {
    if (checkVariable(localStorage.getItem('appointmentEntireForm'))) {
      state.entireForm = JSON.parse(localStorage.getItem('appointmentEntireForm'))
    }

    if (checkVariable(localStorage.getItem('appointmentDates'))) {
      state.dates = JSON.parse(localStorage.getItem('appointmentDates'))
    }

    if (checkVariable(localStorage.getItem('appointmentCostumerDetails'))) {
      state.appointmentCostumerDetails = JSON.parse(localStorage.getItem('appointmentCostumerDetails'))
    }

    if (checkVariable(localStorage.getItem('appointmentTimes'))) {
      state.times = JSON.parse(localStorage.getItem('appointmentTimes'))
    }

    if (checkVariable(localStorage.getItem('appointmentSelectedDate'))) {
      state.selectedDate = JSON.parse(localStorage.getItem('appointmentSelectedDate'))
    }

    if (checkVariable(localStorage.getItem('appointmentSelectedTime'))) {
      state.selectedTime = JSON.parse(localStorage.getItem('appointmentSelectedTime'))
    }
  },

  [types.APPOINTMENT_ENTIRE_FORM](state) {
    state.entireForm = true

    localStorage.setItem('appointmentEntireForm', 'true')
  },

  [types.SET_APPOINTMENT_COSTUMER_DETAILS](state, data) {
    state.appointmentCostumerDetails = data

    localStorage.setItem('appointmentCostumerDetails', JSON.stringify(data))
  },

  [types.GET_DATES_START](state) {
    state.loadingDates = true
    state.dates = []
    state.errorDates = null
  },

  [types.GET_DATES_SUCCESS](state, { data }) {
    state.loadingDates = false
    state.dates = data
    state.errorDates = null

    localStorage.setItem('appointmentDates', JSON.stringify(data))
  },

  [types.GET_DATES_ERROR](state, { error }) {
    state.loadingDates = false
    state.dates = []
    state.errorDates = error
  },

  [types.SET_DATE_APPOINTMENT](state, date) {
    state.selectedDate = date

    localStorage.setItem('appointmentSelectedDate', JSON.stringify(date))
  },

  [types.GET_TIMES_START](state) {
    state.loadingTimes = true
    state.times = []
    state.errorTimes = null
  },

  [types.GET_TIMES_SUCCESS](state, { data }) {
    state.loadingTimes = false
    state.times = data
    state.errorTimes = null

    localStorage.setItem('appointmentTimes', JSON.stringify(data))
  },

  [types.GET_TIMES_ERROR](state, { error }) {
    state.loadingTimes = false
    state.times = []
    state.errorTimes = error
  },

  [types.SET_APPOINTMENT_TIME](state, time) {
    state.selectedTime = time

    localStorage.setItem('appointmentSelectedTime', JSON.stringify(time))
  },
}

export const actions = {
  async loadAppointmentCostumerDetails({ commit }, data) {
    commit(types.SET_APPOINTMENT_COSTUMER_DETAILS, data)
  },

  async getDates({ commit }, { projectId }) {
    try {
      commit(types.GET_DATES_START)

      const { data } = await axios.get(`/api/guest/list_available_appointment_dates/${projectId}`)

      commit(types.GET_DATES_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_DATES_ERROR, { error: e })
    }
  },

  async getTimes({ commit }, { fecha, fechaLegible, diaCitaProyectoId }) {
    try {
      commit(types.SET_DATE_APPOINTMENT, { fecha, fecha_legible: fechaLegible })
      commit(types.GET_TIMES_START)

      const { data } = await axios.get(`/api/guest/list_available_appointment_times/${diaCitaProyectoId}/${fecha}`)

      commit(types.GET_TIMES_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_TIMES_ERROR, { error: e })
    }
  },

  async loadTime({ commit }, { hora_inicio, hora_final }) {
    commit(types.SET_APPOINTMENT_TIME, { hora_inicio, hora_final })
  },
}

// getters
export const getters = {
  entireAppointmentForm: state => state.entireForm,
  loadingDates: state => state.loadingDates,
  dates: state => state.dates,
  errorDates: state => state.errorDates,
  selectedDate: state => state.selectedDate,
  loadingTimes: state => state.loadingTimes,
  times: state => state.times,
  errorTimes: state => state.errorTimes,
  selectedTime: state => state.selectedTime,
  appointmentCostumerDetails: state => state.appointmentCostumerDetails,
}
